import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Container from '../../../containers/master/faculties/facultyListContainer';
import { actions } from '../../../redux/master/faculties';

export default function () {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(actions.getInitData({}));
  }, []);
  return (
    <Container />
  );
}
